import React from 'react';
import { statusTone, titleCase } from '../format';

export default function StatusPill({ value }) {
  if (!value) return <span className="muted">—</span>;
  return <span className={`pill tone-${statusTone(value)}`}>{titleCase(value)}</span>;
}
